module.exports = __webpack_public_path__ + "static/img/dialogLone.31c84fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/dialogLone.png
// module id = PheK
// module chunks = 1